import { isTouchDevice } from "common/utils/browser";
import "./cart-validation-modal.scss";

export default () => {
  if (isTouchDevice()) return;
  const $$modal = $("#cart-validation-modal");

  $$modal.on("hidden.bs.modal", () => {
    document.querySelector(".js-add-to-cart")?.focus();
  });
};
